import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.supported-epm-types.add-epm', {
        url: '/add-epm/:publicServiceId',
        // component: 'companyAddEpm',
        views: {
            '@company': 'companyAddEpm',
        },
        resolve: {
            $breadcrumbs,
            publicService,
            publicServiceId,
        }
    });
}

/** @ngInject */
function $breadcrumbs(publicService) {
    return [{vars: {serviceName: publicService.serviceName}}];
}

/** @ngInject */
function publicService(publicServiceId, publicServicesWithEPM$) {
    return publicServicesWithEPM$.get()
        .then(pss => pss.find(ps => ps.id === publicServiceId));
}

/** @ngInject */
function publicServiceId($stateParams) {
    return $stateParams.publicServiceId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-epm-types/add/add-epm.state.js